import { JSX, useEffect } from 'react';
import { Roleplayer } from '../../common/types/roleplayer';
import { useQuery } from '@tanstack/react-query';
import DataGridLoadingState from '../../common/components/dataGrid/dataGridLoadingState';
import PreloadedClientList, { PreloadedClientListProps } from './preloadedClientList';

export interface ClientListProps extends Omit<PreloadedClientListProps, 'clients'> {
  /**
   * Optional callback that is called when clients are fetched from the server
   * @param clients - fetched clients
   */
  onGetClients?: (clients?: Roleplayer[]) => void;
  /**
   * Optional query parameters
   */
  queryParams?: Record<string, unknown>;
}

/**
 * Component fetches clients from the server and renders them in a table
 */
const ClientList = ({ onGetClients, queryParams, ...props }: ClientListProps): JSX.Element => {
  const { data: clients } = useQuery<Roleplayer[]>({
    queryKey: ['/Roleplayers', queryParams],
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => onGetClients?.(clients), [clients]);

  if (!clients) {
    return <DataGridLoadingState />;
  }

  return <PreloadedClientList {...props} clients={clients} />;
};

export default ClientList;
